
// @ts-expect-error we don't really know if the config is there or not
const createConfig = (env) => {
  const config = {
    environment: env?.MODE,
    isDevelopment: env.DEV,
    isProduction: env.PROD,
    apiPath: env.VITE_APP_API_PATH,
    botPath: env.VITE_APP_BOT_PATH,
    appVersion: env.VITE_APP_VERSION,
    useSRI: env.VITE_APP_USE_SRI === 'true' || false,
    sri: {
      SRI_PRIMUS: env.VITE_SRI_PRIMUS,
      SRI_CSS: env.VITE_SRI_CSS,
      SRI_MAIN: env.VITE_SRI_MAIN,
      SRI_FONT_500: env.VITE_SRI_FONT_500,
      SRI_FONT_REG: env.VITE_SRI_FONT_REG,
    },
  };
  if (!config.apiPath) {
    throw new Error(`env variable is missing: VITE_APP_API_PATH`);
  }
  if (!config.botPath) {
    throw new Error(`env variable is missing: VITE_APP_BOT_PATH`);
  }

  return config;
};


const config = createConfig(import.meta.env || process.env);

export default config;
